import { showSuccessMessage } from 'utils/messages'
import crud from './_crud'
import { callApi } from 'utils/api'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)
const entity = 'programing_services'


const createProgramingServices = (general ={}, gastos=[], unidades=[], correos=[], usuarioNotificacion=[]) => {
    return async (dispatch, getState) => {
        try {
            // console.log('🔄 [Action] Iniciando createProgramingServices...');
            const state = getState()
            // console.log('📋 [Action] Datos a enviar:', { general, gastos, unidades, correos, usuarioNotificacion });
            
            const res = await callApi(`/programing_services/create_programing_services`, {
                method: 'PUT',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify({
                    general,
                    gastos,
                    unidades,
                    correos,
                    usuarioNotificacion,
                }),
            })

            // console.log('✅ [Action] Respuesta recibida:', res.body);

            // if (res.body.message) {
            //     Swal.fire({
            //         icon: 'success',
            //         title: 'Éxito',
            //         text: res.body.message || 'La programación de servicios se creó correctamente',
            //     })
            // }
            return res.body
        } catch (error) {
            console.error('❌ [Action] Error en createProgramingServices:', error);
            throw error;
        }
    }
}

const updateProgramingServices = (general ={}, gastos=[], unidades=[], correos=[], usuarioNotificacion=[]) => {
    return async (dispatch, getState) => {
        try {
            // console.log('🔄 [Action] Iniciando updateProgramingServices...');
            const state = getState()
            // console.log('📋 [Action] Datos a enviar:', { general, gastos, unidades, correos, usuarioNotificacion });

            const res = await callApi(`/programing_services/update_programing_services`, {
                method: 'PUT',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify({
                    id: general?.id,
                    general,
                    gastos,
                    unidades,
                    correos,
                    usuarioNotificacion,
                }),
            })

            // console.log('✅ [Action] Respuesta recibida:', res.body);

            // if (res.body.message) {
            //     Swal.fire({
            //         icon: 'success',
            //         title: 'Éxito',
            //         text: res.body.message || 'La programación de servicios se actualizó correctamente',
            //     })
            // }
            return res.body
        } catch (error) {
            console.error('❌ [Action] Error en updateProgramingServices:', error);
            throw error;
        }
    }
}

const loadAllProgramingServices = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const res = await callApi(`/programing_services/get_programing_services`, {
            method: 'GET',
            json: true,
            headers: {
                Authorization: state.app.user.token,
            },
        })

        if (res.body.message) {
            showSuccessMessage(res.body.message)
        }

        return res.body || []
    }
}

const loadCountOrderServices = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const token = state.app?.user?.token
        if (!token) return {}

        const res = await callApi(`/programing_services/count_service_orders`, {
            method: 'GET',
            headers: {
                Authorization: token,
            },
        })

        // if (res?.body?.message) {
        //     showSuccessMessage(res.body.message)
        // }
        return res.body || []
    }
}

const loadSimpleProgramingServicesCode = (code) => {
    return async (dispatch, getState) => {
        try {
            // console.log(`🔄 [Action] Cargando servicio con código: ${code}`);
            const state = getState();
            const res = await callApi(`/programing_services/get_simple_programing_services_code/${code}`, {
                method: 'GET',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
            });

            // console.log('✅ [Action] Servicio cargado:', res.body);

            // if (res.body.message) {
            //     showSuccessMessage(res.body.message);
            // }

            // console.log("res.body: ", res);

            return res.body || {};
        } catch (error) {
            console.error(`❌ [Action] Error cargando servicio ${code}:`, error);
            if (error.status === 404) {
                console.error(`Service with code ${code} not found.`);
                return null; // Return a fallback value
            }
            throw error; // Re-throw other errors
        }
    };
};

const loadProgramingServicesCode = (code) => {
    return async (dispatch, getState) => {
        try {
            // console.log(`🔄 [Action] Cargando servicio con código: ${code}`);
            const state = getState();
            const res = await callApi(`/programing_services/get_programing_services_code/${code}`, {
                method: 'GET',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
            });

            // console.log('✅ [Action] Servicio cargado:', res.body);

            if (res.body.message) {
                showSuccessMessage(res.body.message);
            }

            return res.body || {};
        } catch (error) {
            console.error(`❌ [Action] Error cargando servicio ${code}:`, error);
            if (error.status === 404) {
                console.error(`Service with code ${code} not found.`);
                return null; // Return a fallback value
            }
            throw error; // Re-throw other errors
        }
    };
};

const loadUnitsWialonInfo = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const { programing_services } = getState();

        // Si ya hay datos recientes (< 5 min), devolverlos sin fetch
        const now = Date.now();
        if (programing_services.lastFetched && now - programing_services.lastFetched < 5 * 60 * 1000) {
            return programing_services.unitsWialonInfo;
        }

        const res = await callApi(`/programing_services/get_units_info_wialon`, {
            method: 'GET',
            json: true,
            headers: {
                Authorization: state.app.user.token,
            },
        })

        if (res.body.message) {
            showSuccessMessage(res.body.message)
        }
        dispatch({ type: 'UNITSWIALONINFO', payload: res.body, lastFetched: Date.now() });
        return res.body || []
    }
}

const deleteAtProgramingServices = (codes = []) => {
    return async (dispatch, getState) => {
        const state = getState()
        const res = await callApi(`/programing_services/deletedAt_programing_services`, {
            method: 'PUT',
            json: true,
            headers: {
                Authorization: state.app.user.token,
            },
            body: JSON.stringify({
                sys_company_id: state.app.user.sys_company_id,
                programing_services_codes: codes,
            }),
        })

        if (res.body.message) {
            Swal.fire({
                icon: 'success',
                title: t('Éxito'),
                text: res.body.message || t('Las programaciones de servicios se eliminaron correctamente'),
                showCloseButton: true,
            })
        }
        return res.body
    }
}

const updateLastService = (unidad={}) => {
    return async (dispatch, getState) => {
        try {
            const state = getState()

            const res = await callApi(`/programing_services/update_last_service`, {
                method: 'PUT',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify({
                    unidad,
                }),
            })
            return res.body
        } catch (error) {
            console.error('❌ [Action] Error en updateLastService:', error);
            throw error;
        }
    }
}

const updateMailAndNotificationUsers = ( notificaciones={}) => {
    return async (dispatch, getState) => {
        try {
            const state = getState()
            const id = notificaciones?.id;
            const correos = Array.isArray(notificaciones?.correos) ? notificaciones.correos : [];
            const usuarioNotificacion = Array.isArray(notificaciones?.usuarioNotificacion) ? notificaciones.usuarioNotificacion : [];
            const res = await callApi(`/programing_services/update_mail_and_notifications_users`, {
                method: 'PUT',
                json: true,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify({
                    ...notificaciones
                }),
            })

            return res.body
        } catch (error) {
            console.error('❌ [Action] Error en updateMailAndNotificationUsers:', error);
            throw error;
        }
    }
}

const actions = crud(
    'programing_services',
    'la programacion de servicio',
    'las programaciones de servicio'
)

export default {
    ...actions,
    createProgramingServices,
    updateProgramingServices,
    loadAllProgramingServices,
    loadSimpleProgramingServicesCode,
    loadProgramingServicesCode,
    loadUnitsWialonInfo,
    deleteAtProgramingServices,
    loadCountOrderServices,
    updateLastService,
    updateMailAndNotificationUsers,
}
